import type { SystemStyleObject } from '@mui/system';
import type { Theme } from '@mui/material/styles';

type StretchedLinkOptions = {
  /** Matches the corner the row itself is cut to, so the overlay does not square it off. */
  radius?: string;
  /** Set where the link owns the row's hover; leave it off where an ancestor already fills. */
  hoverFill?: boolean;
};

/**
 * A link that claims the whole row it sits in: the ::after covers the positioned ancestor, so the
 * row is one hit target and one focus ring rather than a word-sized link inside a larger box.
 */
function stretchedLinkSx(options: StretchedLinkOptions = {}): SystemStyleObject<Theme> {
  const overlay: Record<string, unknown> = { content: '""', position: 'absolute', inset: 0 };
  if (options.radius !== undefined) {
    overlay.borderRadius = options.radius;
  }
  const rules: Record<string, unknown> = { '&::after': overlay };
  if (options.hoverFill === true) {
    rules['&:hover::after'] = { bgcolor: 'action.hover' };
  }
  rules['&:focus-visible::after'] = {
    outline: '2px solid',
    outlineColor: 'primary.main',
    outlineOffset: '-2px',
  };
  return rules as SystemStyleObject<Theme>;
}

export { stretchedLinkSx };
export type { StretchedLinkOptions };
